"use client";
import { PropsWithChildren } from "react";
import { FieldValues, FormProvider, UseFormReturn } from "react-hook-form";

type Props<T extends FieldValues> = {
  methods: UseFormReturn<T>;
  onSubmit: (data: any) => void;
  className?: string;
  id?: string;
};

function Form<T extends FieldValues>({
  methods,
  children,
  onSubmit,
  ...otherProps
}: PropsWithChildren<Props<T>>) {
  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)} {...otherProps}>
        {children}
      </form>
    </FormProvider>
  );
}

export default Form;
